import { useEffect, useState } from "react";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import { useI18n } from "@/lib/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/faq").then((r) => setItems(r.data)); }, []);

  return (
    <div className="bg-white text-[var(--dsf-text)] min-h-screen">
      <Header />
      <section className="pt-32 pb-16 px-6 md:px-12 lg:px-20" data-testid="faq-page">
        <Reveal>
          <div className="max-w-3xl">
            <div className="eyebrow text-[var(--dsf-orange)] mb-3">FAQ</div>
            <h1 className="font-serif text-5xl md:text-7xl text-[var(--dd-green)] leading-[1.02] mb-6">
              {lang === "fr" ? "Questions fréquentes." : "Frequently asked."}
            </h1>
            <p className="text-[var(--dsf-text-secondary)] text-lg">
              {lang === "fr" ? "Tout ce que vous devez savoir sur la maison." : "Everything you need to know about the house."}
            </p>
          </div>
        </Reveal>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-32">
        <div className="max-w-4xl mx-auto">
          <Reveal>
            <Accordion type="single" collapsible className="divide-y divide-[var(--dsf-border)] border-y border-black/5">
              {items.map((it, i) => (
                <AccordionItem key={i} value={`q-${i}`} className="border-b-0" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="font-serif text-xl md:text-2xl text-[var(--dsf-orange)] py-6 hover:no-underline text-left">
                    {lang === "fr" ? it.q : it.q_en}
                  </AccordionTrigger>
                  <AccordionContent className="text-[var(--dsf-orange)]/90 leading-relaxed text-base pb-6">
                    {lang === "fr" ? it.a : it.a_en}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
}
